import './App.css';
import Home from './Container/Home';
import 'bootstrap/dist/css/bootstrap.min.css';
import SignInForm from './Container/Signin';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const currentUser= localStorage.getItem('Aprofile')
  return (
    <div>
      <ToastContainer />
      {currentUser ?
     <Home/> :
     <SignInForm/>
      }
    </div>
  );
}

export default App;
